$('.crypto__card_active').hover((event) => {
    $(event.target.closest('.crypto__card')).addClass('crypto__card_show');
    setTimeout(function () {
        $(event.target.closest('.crypto__card')).removeClass('crypto__card_show');
    }, 400);
})

function createOptions(query, parent) {
    var arrayContainer = [],
        elements = $(`[${query}]`);

    elements.each(function (i) {
        arrayContainer.push(elements[i].getAttribute(query));
    })

    arrayContainer = new Set(arrayContainer);

    arrayContainer.forEach(i => {
        $(`${parent}`).append(`<option value='${i}'>${i}</option>`);
    })
}

function updateRows() {
    var selects = $('[data-element=rowFilter]'),
        filterArray = {},
        queryGen = '';

    selects.each(function (sel) {
        filterArray[$(this).attr('name')] = $(this).val();
    });

    var product_type = $('[name="product-type"]').val();
    if (product_type == 'single_asset' || product_type == 'diversified') {
        queryGen += `[data-product-type="${product_type}"]`;
    }

    Object.keys(filterArray).forEach(key => {
        const val = filterArray[key];
        if (!val) return;
        queryGen += `[${key}="${val}"]`;
    })

    console.log(queryGen)

    $('[data-cur-exchange]').each(function (i) {
        if ($(this).is($(queryGen)) || !Object.keys($(queryGen)).length) {
            $(this).removeClass('d-none');
        } else $(this).addClass('d-none');
    });
}

function updateCur(elems) {
    var newCurrArray = [];

    elems.each(function () {
        newCurrArray.push($(this).attr('data-cur-currency'));
    })

    newCurrArray = new Set(newCurrArray);
    $(`#curName option`).remove();
    newCurrArray.forEach(i => {
        $(`#curName`).append(`<option value='${i}'>${i}</oprion>`);
    })
    updateRows();
}

$('[data-element=rowFilter], #toggleProducts').change(function () {
    updateRows();
    if ($(this).attr('id') == 'exchangeName') {
        updateCur($(`[data-cur-exchange="${$(this).val()}"]`));
    }
})

$(document).ready(function () {
    createOptions('data-cur-exchange', '#exchangeName');
    createOptions('data-cur-currency', '#curName');
    $("#exchangeName").val('Deutsche Börse XETRA').change();
    if ($(this).attr('id') == 'exchangeName') {
        updateCur($(`[data-cur-exchange="${$(this).val()}"]`));
    }
    $("#curName").val('EUR').change();
    updateRows();
    drawValueDirection();
}
)

$('.cryptolist__title-button').click(function(e){
    const trigger = $(this).hasClass('active');

    $(this).toggleClass('active', !trigger);
    $(this).closest('.cryptolist__tr').toggleClass('opened', !trigger);

})